import script from "./TheMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TheMenu.vue?vue&type=script&setup=true&lang=js"

import "./TheMenu.vue?vue&type=style&index=0&id=27e9aa74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27e9aa74"]])

export default __exports__